import React from 'react'
import logo from '../logo.svg'

export const UnauthorizedAccessPage = (props) => {
  return (
    <div style={{margin: 'auto'}}>
      <img src={logo} className="app-logo" alt="logo" />
      <h2>Unauthorized Access</h2>
    </div>
  )
}